import SharedBoardConst from '../constants/shared_board.constants';

export const WsBoardAiAddNew = item => ({
  type: SharedBoardConst.WS_BOARD_AI_NEW,
  value: item,
});
export const WsBoardAiStateChange = item => ({
  type: SharedBoardConst.WS_BOARD_AI_STATE,
  value: item,
});
export const WsBoardAiRagChange = item => ({
  type: SharedBoardConst.WS_BOARD_AI_RAG,
  value: item,
});
export const BoardUpdateS3Data = s3data => ({
  type: SharedBoardConst.WS_BOARD_UPDATE_S3DATA,
  value: s3data,
});
export const WsBoardAiPriorityChange = items => ({
  type: SharedBoardConst.WS_BOARD_AI_PRIORITY,
  value: items,
});
export const WsBoardAiEffortChange = items => ({
  type: SharedBoardConst.WS_BOARD_AI_EFFORT,
  value: items,
});
export const WsBoardAiOwnerChange = items => ({
  type: SharedBoardConst.WS_BOARD_AI_OWNER,
  value: items,
});
export const WsBoardAiStartDateChange = items => ({
  type: SharedBoardConst.WS_BOARD_AI_START_DATE,
  value: items,
});
export const WsBoardAiEndDateChange = items => ({
  type: SharedBoardConst.WS_BOARD_AI_END_DATE,
  value: items,
});
export const WsBoardViewAiPane = items => ({
  type: SharedBoardConst.WS_BOARD_VIEW_AI_PANE,
  value: items,
});
export const WsBoardViewAiPaneAttrCountUpdate = items => ({
  type: SharedBoardConst.WS_BOARD_VIEW_AI_PANE_ATTR_COUNT,
  value: items,
});
export const WsBoardUpdateAiCount = items => ({
  type: SharedBoardConst.WS_BOARD_VIEW_AI_COUNT_UPDATE,
  value: items,
});
export const WbBoardChangeAIDesc = items => ({
  type: SharedBoardConst.WS_BOARD_AI_DESC_CHANGE,
  value: items,
});
export const WbBoardChangeAINotes = items => ({
  type: SharedBoardConst.WS_BOARD_AI_NOTES_CHANGE,
  value: items,
});
export const WsBoardMentionUserData = items => ({
  type: SharedBoardConst.WS_BOARD_MENTION_USER_DATA,
  value: items,
});
export const WsBoardCloseAiPane = items => ({
  type: SharedBoardConst.WS_BOARD_CLOSE_AI_PANE,
  value: items,
});
export const WbBoardAiDelete = items => ({
  type: SharedBoardConst.WS_BOARD_AI_DELETE,
  value: items,
});
export const WsBoardAiUpdate = (id, items) => ({
  type: SharedBoardConst.WS_BOARD_AI_UPDATE,
  id,
  value: items,
});
export const WsBoardUpdateFilters = items => ({
  type: SharedBoardConst.WS_BOARD_UPDATE_FILTERS,
  value: items,
});
export const WsBoardColumnUpdate = (id, items) => ({
  type: SharedBoardConst.WS_BOARD_COLUMN_UPDATE,
  id,
  value: items,
});
export const WsBoardColumnDelete = items => ({
  type: SharedBoardConst.WS_BOARD_COLUMN_DELETE,
  value: items,
});
export const WsBoardAddNewColumn = items => ({
  type: SharedBoardConst.WS_BOARD_ADD_NEW_COLUMN,
});
export const WsBoardTimelineMemberHighlighted = items => ({
  type: SharedBoardConst.WS_BOARD_TIMELINE_MEMBER_HIGHLIGHTED,
  value: items,
});
export const WsBoardTimelineDateChanges = items => ({
  type: SharedBoardConst.WS_BOARD_TIMELINE_DATE_CHANGES,
  value: items,
});
export const WsBoardColumnSort = (id, items, oldCol, aiId) => ({
  type: SharedBoardConst.WS_BOARD_COLUMN_SORT,
  id,
  value: items,
  oldCol,
  aiId,
});
export const WsBoardColumnHeadingSort = items => ({
  type: SharedBoardConst.WS_BOARD_COLUMN_HEADING_SORT,
  value: items,
});
export const WsBoardColumnReorder = items => ({
  type: SharedBoardConst.WS_BOARD_COLUMN_REORDER,
  value: items,
});
export const WsboardAiparentUpdate = (id, parentId) => ({
  type: SharedBoardConst.WS_BOARD_AI_PARENT_UPDATE,
  id,
  parentId,
});
export const WbBoardColColorChange = (id, items) => ({
  type: SharedBoardConst.WS_BOARD_COL_COLOR_CHANGE,
  id,
  value: items,
});
export const BoardUpdateSharedMembers = item => ({
  type: SharedBoardConst.BOARD_UPDATE_SHARED_MEMBERS,
  item,
});
export const BoardUpdateBoardData = item => ({
  type: SharedBoardConst.BOARD_UPDATE_BOARD_DATA,
  item,
});
export const BoardAddNewItemsInColumn = item => ({
  type: SharedBoardConst.BOARD_ADD_NEW_ITEMS_IN_COLUMN,
  item,
});
export const BoardDelteItemInColumn = item => ({
  type: SharedBoardConst.BOARD_DELETE_ITEM_IN_COLUMN,
  value: item,
});
export const BoardUpdateItemInColumn = item => ({
  type: SharedBoardConst.BOARD_UPDATE_ITEM_IN_COLUMN,
  value: item,
});
export const BoardUpdateBoardThemes = item => ({
  type: SharedBoardConst.BOARD_UPDATE_BOARD_THEMES,
  item,
});
export const BoardWsDataUpate = item => ({
  type: SharedBoardConst.BOARD_WS_DATA_UPDATE,
  item,
});
export const BoardFreeTextUpdate = (id, arr) => ({
  type: SharedBoardConst.BOARD_FREETEXT_UPDATE,
  id,
  value: arr,
});
export const BoardFreeTextAdd = item => ({
  type: SharedBoardConst.BOARD_FREETEXT_ADD,
  item,
});
export const BoardAutomationUpdate = (items, params, duplicateItem, timeline = false) => ({
  type: SharedBoardConst.BOARD_AUTOMATION_UPDATE,
  items,
  params,
  duplicateItem,
  timeline,
});
export const BoardAutomationColUpdate = (id, act) => ({
  type: SharedBoardConst.BOARD_AUTOMATION_COL_UPDATE,
  id,
  act,
});
export const BoardUpdateUserPermission = item => ({
  type: SharedBoardConst.BOARD_UPDATE_USER_PERM,
  item,
});

export const BoardAddTag = (aiId, item) => ({
  type: SharedBoardConst.WS_BOARD_ADD_TAG,
  aiId,
  item,

});

export const BoardRemoveTag = (aiId, tagId) => ({
  type: SharedBoardConst.WS_BOARD_REMOVE_TAG,
  aiId,
  tagId,

});

export const UpdateBoardColVal = (oldCol, newCol, aid) => ({
  type: SharedBoardConst.WS_BOARD_UPDATE_COL_VAL,
  aiId: aid,
  newCol,
  oldCol,

});
